import React from 'react';
import Container from '@Theme/natucare/components/Container/Container';
import Breadcrumbs from '@Theme/natucare/components/Breadcrumbs/Breadcrumbs';
import * as styles from './GenericHeading.module.scss';
const GenericHeading = props => {
  const {
    breadcrumbs,
    heading,
    description,
    variant
  } = props;
  if (!heading) {
    return false;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: `${styles.root} ${variant ? styles[`root${variant}`] : ''}`
  }, /*#__PURE__*/React.createElement(Container, {
    classname: styles.rootContainer
  }, breadcrumbs && /*#__PURE__*/React.createElement(Breadcrumbs, {
    items: breadcrumbs,
    classname: styles.rootBreadcrumbs
  }), heading && /*#__PURE__*/React.createElement("h1", {
    className: styles.rootHeading
  }, heading), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description)));
};
export default GenericHeading;